import { TableColumn } from "../table/TableColumn";

const AccessGroupActionColumns : TableColumn[] =[
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        // sortByName: "devAction.setting.nameOriginal",
        // sortDirection: "asc",
        active: true,
        translationKey: "name"
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 1,
        sortByName: "devAction.setting.settingType.nameOriginal",
        sortDirection: "asc",
        active: true,
        translationKey: "type"
        // searchOnName: "devAction.setting.settingType.nameOriginal",
        // lookupName: "devAction.setting.settingType.nameOriginal"
    },
    {
        heading: "Device",
        accessor: "device",
        isNumeric: false,
        id: 2,
        sortByName: "devAction.deviceImprox.devName",
        sortDirection: "asc",
        active: true,
        translationKey: "device"
        // searchOnName: "devAction.deviceImprox.devName",
        // lookupName: "devAction.deviceImprox.devName"
    },
];

export default AccessGroupActionColumns;
